<script>
import ParticipantLeaderboard from '@/components/cards/ParticipantLeaderboard.vue'
import { mapGetters } from 'vuex'
import StatisticCards from '@/components/StatisticCards.vue'
import DiscoverMoments from '@/components/cards/DiscoverMoments.vue'
import ThankYouCard from '@/components/cards/ThankYouCard.vue'

export default {
  components: {
    DiscoverMoments, StatisticCards, ParticipantLeaderboard, ThankYouCard
  },
  computed: {
    ...mapGetters([
      'mode',
      'globalLeader'
    ])
  }
}
</script>

<template>
  <aside-container>
    <transition name="fade">
      <div class="view-spacing">
        <section>
          <ParticipantLeaderboard
            :header="$t('welcome.globalWinners')"
            :value="globalLeader"
          />
          <ThankYouCard/>
          <StatisticCards/>
          <StatisticCards type="funFacts"/>
          <DiscoverMoments/>
        </section>
      </div>
    </transition>
  </aside-container>
</template>
